import { z } from "zod";

export type Props = {
	fundId?: number;
	config: string;
};

export const EntitiesSchema = z.object({
	data: z.tuple([z.string(), z.string().nullable()]).array(),
});
export type Entities = z.infer<typeof EntitiesSchema>;

export const SummaryRowSchema = z.tuple([
	z.string(),
	z.string(),
	z.string(),
	z.string(),
	z.string(),
	z.string(),
	z.string(),
	z.string(),
	z.string(),
]);
export type SummaryRow = z.infer<typeof SummaryRowSchema>;

export const SummaryDataSchema = z.object({
	data: SummaryRowSchema.array(),
	headers: SummaryRowSchema,
	header: z.string().optional(),
});
export type SummaryData = z.infer<typeof SummaryDataSchema>;

export const AnnualisedRowSchema = z.tuple([
	z.string(),
	z.string(),
	z.string(),
	z.string(),
]);
export type AnnualisedRow = z.infer<typeof AnnualisedRowSchema>;

export const AnnualisedDataSchema = z.object({
	data: AnnualisedRowSchema.array(),
	headers: AnnualisedRowSchema,
	header: z.string(),
});
export type AnnualisedData = z.infer<typeof AnnualisedDataSchema>;

export const YearOnYearRowSchema = z.string().array();
export type YearOnYearRow = z.infer<typeof YearOnYearRowSchema>;

export const YearOnYearDataSchema = z.object({
	data: YearOnYearRowSchema.array(),
	headers: YearOnYearRowSchema,
});
export type YearOnYearData = z.infer<typeof YearOnYearDataSchema>;

export const NoteSchema = z.object({
	text: z.string(),
});

export const MessageSchema = z.object({
	lessThanYearOld: z.object({ text: z.string() }),
});

export const ChartConfigSchema = z.object({
	note: z.string(),
	partId: z.number(),
	priceType: z.string(),
	calculationBasis: z.string(),
	periodLength: z.enum(["1y", "3y", "5y", "10y", "sl"]),
	asAtDate: z.coerce.date(),
});
export type ChartConfig = z.infer<typeof ChartConfigSchema>;

export const MonthlyDataSchema = z.object({
	data: z.array(z.array(z.string())),
	headers: z.array(z.string()),
	partConfig: z.string(),
	note: z.string(),
	header: z.string(),
});
export type MonthlyData = z.infer<typeof MonthlyDataSchema>;

export const PerformanceSectionSchema = z.object({
	entities: EntitiesSchema.or(EntitiesSchema.array()),
	summary: z.tuple([SummaryDataSchema, AnnualisedDataSchema]),
	yearOnYear: YearOnYearDataSchema,
	monthly: MonthlyDataSchema.optional(),
	note: NoteSchema.or(z.object({})).optional(),
	messages: MessageSchema,
	chart: ChartConfigSchema.optional(),
});
export type PerformanceSection = z.infer<typeof PerformanceSectionSchema>;

export type TableData = {
	data: string[][];
	headers: string[];
};

export type TabName =
	| "summary"
	| "yoy"
	| "monthly"
	| "cumulative"
	| "chart"
	| "annualised";
